import script from "./tree-menu-loading-state.vue?vue&type=script&lang=ts&setup=true"
export * from "./tree-menu-loading-state.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__